import React, { useState, useEffect } from 'react';
import { func } from 'prop-types';
import {
  ButtonGroup,
  Button,
  Typography,
} from '@material-ui/core';
import {
  ThumbDown,
  ThumbUp,
} from '@material-ui/icons';

import {
  MeetingContextMeetingControlsProps,
  withMeetingContext,
} from 'Scenes/_root/meetingContext';
import styles from './styles.scss';

export const PatientMeetingComplete = ({
  registerMeetingCallbacks,
  meetingControls,
  openMeetingFeedbackModal,
}) => {
  const [hasSubmitted, setHasSubmitted] = useState(meetingControls.getHasSubmittedFeedback());

  const onSubmittedFeedback = () => {
    setHasSubmitted(true);
    meetingControls.dismissFeedback();
  };

  const submitPositiveFeedback = () => {
    meetingControls.submitFeedback('NA', true);
  };

  useEffect(() => registerMeetingCallbacks('patientMeetingComplete', {
    onSubmittedFeedback,
  }), []);

  return (
    <div className={styles.patientMeetingCompleteWrapper}>
      <div className={styles.heading}>
        <Typography variant='h2'>Consult ended</Typography>
        <Typography variant='body1'>Thank you for using TeleConsult.</Typography>
        {!hasSubmitted && (
          <React.Fragment>
            <Typography
              color='secondary'
              variant='body1'
            >
              Did your call work as expected?
            </Typography>
            <ButtonGroup
              fullWidth
              color='secondary'
              size='small'
            >
              <Button onClick={submitPositiveFeedback}>
                <ThumbUp />
              </Button>
              <Button onClick={openMeetingFeedbackModal}>
                <ThumbDown />
              </Button>
            </ButtonGroup>
          </React.Fragment>
        )}
      </div>
    </div>
  );
};

PatientMeetingComplete.propTypes = {
  meetingControls: MeetingContextMeetingControlsProps,
  registerMeetingCallbacks: func.isRequired,
  openMeetingFeedbackModal: func.isRequired,
};

export default withMeetingContext(['registerMeetingCallbacks', 'meetingControls'])(PatientMeetingComplete);
